import { useState, useEffect } from 'react';
import { Session } from '@supabase/supabase-js';
import { supabase, APP_ENV } from './lib/supabaseClient';
import { apiClient } from './lib/apiClient';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';

export default function App() {
  const [session, setSession] = useState<Session | null>(null);
  const [jwtAuthenticated, setJwtAuthenticated] = useState<boolean>(apiClient.isAuthenticated());
  const [loading, setLoading] = useState(true);

  const checkAuth = () => {
    setJwtAuthenticated(apiClient.isAuthenticated());
  };

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleLogout = async () => {
    apiClient.clearSession();
    setJwtAuthenticated(false);
    await supabase.auth.signOut();
  };

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-950 text-amber-400">
        <div className="text-xl font-semibold animate-pulse">Chargement de ConteDuSoir Admin...</div>
      </div>
    );
  }

  const isLoggedIn = jwtAuthenticated || !!session;
  const loggedUserEmail = apiClient.getUser()?.email || session?.user?.email || 'admin@contedusoir.app';

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <header className="border-b border-slate-800 bg-slate-900/80 px-6 py-4 flex justify-between items-center backdrop-blur">
        <div className="flex items-center gap-3">
          <span className="text-2xl">📖</span>
          <div>
            <h1 className="text-lg font-bold text-amber-400">ConteDuSoir — Web Admin</h1>
            <p className="text-xs text-slate-400">Éditeur : DOM APPS (Dominique Richebon)</p>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <span className={`px-3 py-1 text-xs font-semibold rounded-full ${
            APP_ENV === 'production' 
              ? 'bg-red-950 text-red-400 border border-red-800' 
              : 'bg-emerald-950 text-emerald-400 border border-emerald-800'
          }`}>
            ENV : {APP_ENV.toUpperCase()}
          </span>
          {isLoggedIn && (
            <div className="flex items-center gap-3">
              <span className="text-xs text-slate-300 bg-slate-800 px-2.5 py-1 rounded border border-slate-700">
                👤 {loggedUserEmail}
              </span>
              <button
                onClick={handleLogout}
                className="px-3 py-1.5 text-xs bg-slate-800 hover:bg-slate-700 text-slate-200 rounded-md border border-slate-700"
              >
                Déconnexion
              </button>
            </div>
          )}
        </div>
      </header>

      <main className="p-6">
        {isLoggedIn ? <Dashboard /> : <Login onLoginSuccess={checkAuth} />}
      </main>
    </div>
  );
}

